import { useEffect, useState } from "react";

export const useTrueOrFalseQuestions = (
  generatedQuestionsFromSubmitContent,
  setTotalQuestionNumber,
  totalQuestionNumber
) => {
  const [trueFalseQuestions, setTrueFalseQuestions] = useState([]);

  const Version = localStorage.getItem("userVersion");

  function cleanText(text = "") {
    return text.replace(/\\n|[\n\r]/g, "").trim();
  }

  const handleTrueOrFalseQuestionsEdit = (index) => {
    const updatedQuestions = [...trueFalseQuestions];
    updatedQuestions[index].editing = !updatedQuestions[index].editing;

    if (updatedQuestions[index].editing) {
      // After setting editing to true, focus on the contentEditable div for the question
      setTimeout(() => {
        const contentEditableElement = document.getElementById(
          `question-${index}`
        ); // Add an ID to your contentEditable element
        if (contentEditableElement) {
          contentEditableElement.focus();
        }
      }, 0);
    }

    setTrueFalseQuestions(updatedQuestions);
  };

  const handleTrueOrFalseQuestionDelete = (index) => {
    let updatedQuestions = [...trueFalseQuestions];
    updatedQuestions.splice(index, 1); // Remove the question at the given index
    updatedQuestions = updatedQuestions.map((u, i) => ({ ...u, index: i }));
    setTotalQuestionNumber(totalQuestionNumber - 1);
    setTrueFalseQuestions(updatedQuestions);
  };

  const handleTrueOrFalseQuestionChange = (index, newValue) => {
    const updatedQuestions = [...trueFalseQuestions];

    if ('question' in updatedQuestions[index]){
      updatedQuestions[index].question = newValue;
    }else if ('Question' in updatedQuestions[index]){
      updatedQuestions[index].Question = newValue; 
    }
    setTrueFalseQuestions(updatedQuestions);
  };

  const handleTrueOrFalseAnswersEdit = (index) => {
    const updatedQuestions = [...trueFalseQuestions];
    if (updatedQuestions[index]) {
      updatedQuestions[index].editingAnswer =
        !updatedQuestions[index].editingAnswer;
      setTrueFalseQuestions(updatedQuestions);
    }
  };

  const handleTrueOrFalseAnswerChange = (index, newValue) => {
    const updatedQuestions = [...trueFalseQuestions];

    if('answer' in updatedQuestions[index]){
      updatedQuestions[index].answer = newValue;
    }else if ('Answer' in updatedQuestions[index]){
      updatedQuestions[index].Answer = newValue;
    }
    setTrueFalseQuestions(updatedQuestions);
  };

  useEffect(() => {
    if (generatedQuestionsFromSubmitContent) {
      let trueFalse =
        generatedQuestionsFromSubmitContent.response?.questions?.questionset
          ?.true_false_questions?.questions ||
        generatedQuestionsFromSubmitContent.response?.questions?.questionset
          ?.true_false_questions ||
        generatedQuestionsFromSubmitContent.questionset?.true_false_questions
          ?.questions ||
        generatedQuestionsFromSubmitContent.questionset?.true_false_questions ||
        [];

      if (Version === "PRO") {
        // Add category and index, and pick a random question from questionList
        trueFalse = trueFalse.map((t, index) => ({
          ...t,
          category: "truefalse",
          index,
        }));
      } else {
        trueFalse = trueFalse.map((t, index) => ({
          ...t,
          category: "truefalse",
          index,
        }));
      }
      // console.log("trueFalse :", trueFalse);
      setTrueFalseQuestions(trueFalse);
    }
  }, [generatedQuestionsFromSubmitContent]);

  return {
    trueFalseQuestions,
    handleTrueOrFalseQuestionsEdit,
    handleTrueOrFalseQuestionDelete,
    handleTrueOrFalseQuestionChange,
    handleTrueOrFalseAnswersEdit,
    handleTrueOrFalseAnswerChange,
  };
};
